module.exports = __webpack_public_path__ + "static/ceramics-thumbnail-dea0cd6b76d8959dce80dec8b4bae3dd.jpg";